import React, { useState, useRef, useEffect } from "react";
import styled, { keyframes } from "styled-components";
import theme from "../../../assets/theme";
import useLoader from "../../../hooks/useLoader";
import AWSService from "../../../services/AWSService";
import { useSnackbar } from "notistack";
import { getErrorMessage } from "../../../helpers/functions";
import CaseService from "../../../services/CaseService";
import CaseDescriptionModal from "../CaseDescriptionModal";
import DocumentUploadModal from "../MultipleDocumentUploadModal";
import RefundModal from "../RefundModal";
import ViewNotesModal from "../../internal/ViewNotesModal";
import ClaimItemsListModal from "../../common/ClaimItemsListModal/index";
import HearingDate from "../../internal/HearingDate/index";
import AlertDialog from "../Alert";
import CounterClaimModal from "../ClaimItemsListModal/CounterClaim";
import GenerateInvoiceModal from "../ClaimItemsListModal/GenerateInvoice";
import HearingTimeline from "../HearingTimeLine";
import TrackingModal from "../CaseDetails/component/TrackingModal";
import RespondentPartiesModal from "../CaseDetails/component/RespondentPartiesModal";
import NumberFormat from "react-number-format";
import { CustomInputField } from "../FormInputs";
import { CloseBtn } from "../../internal/BulkUpdate";
import DisputeModal from "../CaseDetails/component/DisputeModal";
import { CaseHeader } from "./components/CaseHeader";
import { CaseTabStrip } from "./components/CaseTabStrip";
import DocumentsSection from "./HearingBundles/DocumentsLanding";
import CaseDetails from "./components/CaseDetails";
import AgentDetailsModal from "./components/AgentModal";
import PaymentsTab from "./components/PaymentsTab";
import HearingsTab from "./components/HearingsTab";
import CaseDiscovery from "./components/CaseDiscovery";
import AgentListModal from "./components/ViewOnlyModal";
import EpeAccessProvider from "../../../providers/EpeAccessProvider";

const ClaimValueModal = ({ open, onClose, caseDetails, onSuccess }) => {
  const { setLoader, setShowDrawer } = useLoader();
  const { enqueueSnackbar } = useSnackbar();
  const [value, setValue] = useState(caseDetails?.totalClaimValue || "");
  const [error, setError] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    setShowDrawer(true); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (open) {
      setValue(caseDetails?.totalClaimValue || "");
    } // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  if (!open) return null;

  const handleSave = async () => {
    if (!value && value !== 0) {
      setError("Claim value is required");
      return;
    }
    try {
      setSaving(true);
      setLoader({ state: true, message: "Updating claim value..." });
      await CaseService.updateCase(caseDetails.id, { totalClaimValue: value });
      enqueueSnackbar("Claim value updated successfully", {
        variant: "success",
      });
      onSuccess();
      onClose();
    } catch (err) {
      const message = getErrorMessage(err);
      enqueueSnackbar(message, { variant: "error" });
    } finally {
      setSaving(false);
      setLoader({ state: false });
    }
  };

  return (
    <ModalOverlay onClick={(e) => e.target === e.currentTarget && onClose()}>
      <ModalBox>
        <ModalHeader>
          <ModalTitleGroup>
            <div>
              <ModalTitle>Update Claim Value</ModalTitle>
              <ModalSub>Enter the updated total claim amount</ModalSub>
            </div>
          </ModalTitleGroup>
          <CloseBtn onClick={onClose} aria-label="Close">
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <line x1="18" y1="6" x2="6" y2="18" />
              <line x1="6" y1="6" x2="18" y2="18" />
            </svg>
          </CloseBtn>
        </ModalHeader>

        <ModalBody>
          <FieldLabel>
            Claim Value <span className="required-star"> *</span>
          </FieldLabel>
          <NumberFormat
            thousandSeparator
            thousandsGroupStyle="lakh"
            isNumericString={true}
            decimalScale={2}
            fixedDecimalScale
            allowNegative={false}
            className={"input-white"}
            displayType={"input"}
            value={value}
            type={"text"}
            customInput={CustomInputField}
            name={"totalClaimValue"}
            onValueChange={({ value: v }) => {
              setValue(v);
              if (v) setError("");
            }}
            variant="outlined"
            helperText={error}
            error={!!error}
            placeholder="0.00"
          />
          {caseDetails?.currencyUnit && (
            <CurrencyHint>Currency: {caseDetails.currencyUnit}</CurrencyHint>
          )}
        </ModalBody>

        <ModalFooter>
          <SaveBtn onClick={handleSave} disabled={saving}>
            {saving ? (
              <SpinnerWrap>
                <Spinner />
                Saving...
              </SpinnerWrap>
            ) : (
              "Update Claim Value"
            )}
          </SaveBtn>
        </ModalFooter>
      </ModalBox>
    </ModalOverlay>
  );
};

const Index = ({
  caseDetails,
  setState,
  id,
  MTRef,
  isActionsDisabled = false,
  partyList = [],
  isViewAction = false,
  pendingRegistrationFee,
  setOpenPaymentBox,
  disableRefund,
  refreshDetails,
  setRefreshDetails,
  docUploadModal,
  setDocUploadModal,
  fields,
  setFields,
  viewOnly,
  requestedSmartOdrAction,
  setRequestedSmartOdrAction,
  onSmartOdrActionContinue,

  items,
  resolutionKind,
  selectedIndex,
  isMediation,
  status,
  currentStateKey,
  setStatusModal,

  removeMediator,
  presidingArbitrator,
  addMediator,
  tab,
  setTab,
  view,
  setView,

  //hearings
  state,
  isNonNegotiation,
  isNotDraft,
  mediatorTitle,
  meetingOpen,
  setSettingsModal,
  setPublicModal,
  transcriptControl,
  settranscriptControl,
  meetingDetail,
  stopTranscriptionAlert,
  pushCaseToArbitrationAlert,
  startTranscription,
  setRefreshStatus,
  generateRTMPLink,
  joinMeetingAlert,
  activeDoc,
  setActiveDoc,
  currentState
}) => {
  const fileRef = useRef();
  const { setLoader } = useLoader();
  const { enqueueSnackbar } = useSnackbar();
  const [file] = useState([]);
  const [modal, setModal] = useState();
  const [url, setUrl] = useState("");
  const [openRefundModal, setOpenRefundModal] = useState(false);
  const [opendrawer, setOpenDrawer] = useState(false);
  const [viewNotes, setViewNotes] = useState(false);
  const [opendrawerClaim, setOpenDrawerClaim] = useState(false);
  const [openHearing, setOpenHearing] = useState(false);
  const [openAlert, setOpenAlert] = useState(false);
  const [alertData, setAlertData] = useState({});
  const [data, setData] = useState([]);
  const [claimModal, setClaimModal] = useState(false);
  const [invoiceModal, setInvoiceModal] = useState({ state: false });
  const [timelineModal, setTimelineModal] = useState({ state: false });
  const [trackingModal, setTrackingModal] = useState({ state: false });
  const [respondentModal, setRespondentModal] = useState(false);
  const [claimValueModal, setClaimValueModal] = useState(false);
  const [disputeModal, setDisputeModal] = useState({});
  const [trigger, setTrigger] = useState(false);
  const [paymentsModal, setPaymentsModal] = useState(false);

  async function s3Upload(file) {
    if (file) {
      let len = file.length;
      let fileName = [];
      for (let i = 0; i < len; i++) fileName.push(file[i]?.name);
      try {
        setLoader({ state: true, message: `Uploading file...` });
        const payload = { key: fileName };
        const s3Response = await AWSService.getS3URL(payload);
        if (s3Response.url) {
          const s3url = [];
          for (let i = 0; i < len; i++) {
            const res = await AWSService.uploadToS3(
              s3Response?.url[i],
              file[i],
            );
            s3url.push(res);
          }
          setUrl(s3url);
        }
      } catch (error) {
        const message = getErrorMessage(error);
        enqueueSnackbar(message, { variant: "error" });
      } finally {
        setLoader({ state: false });
      }
    }
  }

  async function addDocumentForCase(data) {
    try {
      setLoader({ state: true, message: `Uploading document` });
      const documentDetails = data;
      await CaseService.caseAddDocument({ documentDetails }, id);
      enqueueSnackbar("Successfully Uploaded", { variant: "success" });
      if (MTRef?.current?.onSearchChange) MTRef.current.onSearchChange("");
      setData([]);
    } catch (error) {
      const message = getErrorMessage(error);
      enqueueSnackbar(message, { variant: "error" });
    } finally {
      setLoader({ state: false });
      setOpenAlert(false);
      setDocUploadModal(false);
      setAlertData({});
    }
  }

  async function postReportDetails() {
    try {
      setLoader({ state: true, message: `posting` });
      const res = await CaseService.postReportDetails(
        id,
        caseDetails.resolutionKind,
      );
      if (res.success) {
        enqueueSnackbar(res?.message, { variant: "success" });
      }
    } catch (error) {
      const message = getErrorMessage(error);
      enqueueSnackbar(message, { variant: "error" });
    } finally {
      setLoader({ state: false });
    }
  }

  async function fetchReportDetails(action) {
    try {
      setLoader({ state: true, message: `fetch report...` });
      const res = await CaseService.fetchReportDetails(
        id,
        caseDetails.resolutionKind,
      );
      if (res.success) {
        const isTrigger =
          res?.data?.isTrigger === true || res?.data?.istrigger === true;
        if (action && !isTrigger) {
          enqueueSnackbar(
            "Please trigger Smart ODR before closing or marking this case as success.",
            { variant: "error" },
          );
          return;
        }
        setDisputeModal({
          state: true,
          disputeData: res?.data,
          pendingAction: action,
        });
      }
    } catch (error) {
      const message = getErrorMessage(error);
      enqueueSnackbar(message, { variant: "error" });
    } finally {
      setLoader({ state: false });
    }
  }

  useEffect(() => {
    if (!requestedSmartOdrAction) return;

    fetchReportDetails(requestedSmartOdrAction);
    setRequestedSmartOdrAction(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [requestedSmartOdrAction]);

  const openTrackingModal = () => {
    setTrackingModal({
      state: true,
      trackingData: caseDetails?.trackingNumbers,
    });
  };

  return (
    // One EPE (JustCue) access poller for the entry tab and the case sheet; EPE is not used for negotiation.
    <EpeAccessProvider
      caseId={caseDetails?.id}
      enabled={
        !!caseDetails?.resolutionKind &&
        caseDetails.resolutionKind !== "negotiation"
      }
    >
      {activeDoc ? null : (
        <StickyHeader>
          <CaseHeader
            {...{
              caseDetails,
              setViewNotes,
              status,
              setFields,
              fetchReportDetails,
              postReportDetails,
              setOpenHearing,
              setTimelineModal,
              opendrawer,
              setOpenDrawer,
              viewOnly,
              claimValueModal,
              setClaimValueModal,
            }}
          />
          <CaseTabStrip
            active={tab}
            onChange={setTab}
            {...{ caseDetails, view, setView }}
          />
        </StickyHeader>
      )}

      {tab.key === "sheet" ? (
        <>
          <CaseDetails
            caseObj={caseDetails}
            {...{
              setOpenDrawer,
              items,
              resolutionKind,
              selectedIndex,
              isMediation,
              status,
              currentStateKey,
              setStatusModal,
              removeMediator,
              presidingArbitrator,
              addMediator,
              openTrackingModal,
              setOpenHearing,
              setTimelineModal,
              setFields,
              partyList,
              viewOnly,
              pushCaseToArbitrationAlert,
              openPayments: () => setPaymentsModal(true),
              setRespondentModal,
              setRefreshDetails,
              currentState
            }}
          />
        </>
      ) : tab.key === "documents" ? (
        <DocumentsSection
          {...{
            caseDetails,
            isActionsDisabled,
            viewOnly,
            view,
            setView,
            trigger,
            setTrigger,
          }}
          onChange={setTab}
          id={id}
        />
      ) : tab.key === "discovery" ? (
        <CaseDiscovery />
      ) : (
        caseDetails?.resolutionKind !== "negotiation" && (
          <HearingsTab
            open={true}
            setOpen={() => {}}
            caseId={id}
            id={id}
            type={caseDetails?.resolutionKind}
            {...{
              viewOnly,
              state,
              isActionsDisabled,
              isNonNegotiation,
              isNotDraft,
              mediatorTitle,
              meetingOpen,
              setSettingsModal,
              setPublicModal,
              transcriptControl,
              settranscriptControl,
              setRefreshDetails,
              meetingDetail,
              stopTranscriptionAlert,
              pushCaseToArbitrationAlert,
              caseDetails,
              tab,
              startTranscription,
              setRefreshStatus,
              generateRTMPLink,
              MTRef,
              joinMeetingAlert,
            }}
          />
        )
      )}

      <ClaimValueModal
        open={claimValueModal}
        onClose={() => setClaimValueModal(false)}
        caseDetails={caseDetails}
        onSuccess={() => {
          if (MTRef?.current?.onSearchChange) MTRef.current.onSearchChange("");
          setRefreshDetails((r) => !r);
        }}
      />

      {respondentModal && (
        <RespondentPartiesModal
          open={respondentModal}
          setOpen={setRespondentModal}
          respondentParties={caseDetails?.respondentParties}
          id={caseDetails.id}
          {...{ setRefreshDetails }}
        />
      )}
      {trackingModal?.state && (
        <TrackingModal {...{ trackingModal, setTrackingModal }} />
      )}
      {invoiceModal?.state && (
        <GenerateInvoiceModal
          {...{ invoiceModal, setInvoiceModal }}
          caseId={caseDetails.id}
        />
      )}
      {disputeModal?.state && (
        <DisputeModal
          {...{
            disputeModal,
            setDisputeModal,
            caseDetails,
            onContinue: onSmartOdrActionContinue,
            onTrigger: postReportDetails,
          }}
        />
      )}

      {opendrawer.state && (
        <AgentDetailsModal
          onClose={() => setOpenDrawer({ state: false })}
          partyData={opendrawer.partyList}
        />
      )}

      <AgentListModal
        {...{
          opendrawer,
          setOpenDrawer,
          MTRef,
          partyList,
          displayAuthUrl: false,
          caseDetails,
          setRefreshDetails,
          viewOnly,
        }}
        open={opendrawer?.state}
        onClose={() => setOpenDrawer({ state: false })}
      />

      <ClaimItemsListModal
        {...{
          opendrawerClaim,
          setOpenDrawerClaim,
          MTRef,
          displayAuthUrl: false,
        }}
        caseDetails={caseDetails}
      />
      <CounterClaimModal
        {...{ claimModal, setClaimModal, MTRef, caseDetails }}
      />
      <HearingDate
        {...{ openHearing, setOpenHearing, refreshDetails, setRefreshDetails }}
        caseDetails={caseDetails}
      />
      <ViewNotesModal
        disabled={isActionsDisabled}
        modal={viewNotes}
        setModal={setViewNotes}
        type={"Case Manager"}
        id={id}
        {...{ viewOnly }}
      />
      <CaseDescriptionModal
        {...{ modal, setModal }}
        description={caseDetails?.description}
      />
      <RefundModal
        id={caseDetails?.id}
        {...{ openRefundModal, setOpenRefundModal, viewOnly }}
        heading="Refund Payment"
        btnText="Refund Payment"
      />
      {timelineModal?.state && (
        <HearingTimeline {...{ timelineModal, setTimelineModal }} />
      )}
      <DocumentUploadModal
        modal={docUploadModal}
        setModal={setDocUploadModal}
        handleUpload={s3Upload}
        file={file}
        fileRef={fileRef}
        url={url}
        data={data}
        setData={setData}
        setUrl={setUrl}
        resolutionKind={caseDetails?.resolutionKind}
        shareDefault={caseDetails?.resolutionKind}
        handleSuccess={(data) => {
          setOpenAlert(true);
          setAlertData({
            clickSecondarybtn: () => setOpenAlert(false),
            onDialogClose: () => setOpenAlert(false),
            primaryBtnText: "OK",
            secondaryBtnText: "Cancel",
            desc:
              data && data.length === 1
                ? `${
                    data[0]["visibilityType"] === "all"
                      ? "Are you sure you want to share this document with all parties?"
                      : data[0]["visibilityType"] === "me"
                        ? "Are you sure you want to keep this document share with my team?"
                        : data[0]["visibilityType"] === "strictMode"
                          ? "Are you sure you want to keep this document private?"
                          : "Are you sure you want to share this document with Case Managers & Neutral(s)?"
                  }`
                : "Are you sure you want to share this document?",
            heading: `Alert`,
            clickPrimaryBtn: () => addDocumentForCase(data),
          });
        }}
        hasDocumentType={caseDetails?.resolutionKind === "arbitration"}
      />
      <AlertDialog
        isOpen={openAlert}
        {...{ ...alertData }}
        descriptionTextStyle={{ textAlign: "left" }}
      />
      {paymentsModal && (
        <ModalOverlay
          onClick={(e) =>
            e.target === e.currentTarget && setPaymentsModal(false)
          }
        >
          <ModalBox style={{ maxWidth: "900px", maxHeight: "90vh", overflowY: "auto" }}>
            <ModalHeader>
              <ModalTitle>Payments</ModalTitle>
              <CloseBtn
                onClick={() => setPaymentsModal(false)}
                aria-label="Close payments"
              >
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <line x1="18" y1="6" x2="6" y2="18" />
                  <line x1="6" y1="6" x2="18" y2="18" />
                </svg>
              </CloseBtn>
            </ModalHeader>
            <PaymentsTab
              open={paymentsModal}
              setOpen={setPaymentsModal}
              caseId={id}
              id={id}
              {...{ viewOnly }}
            />
          </ModalBox>
        </ModalOverlay>
      )}
    </EpeAccessProvider>
  );
};

export default Index;

export const fadeIn = keyframes`from { opacity: 0 } to { opacity: 1 }`;
export const slideUp = keyframes`
 from { opacity: 0; transform: translateY(20px) scale(0.98) }
 to { opacity: 1; transform: translateY(0) scale(1) }
`;
const spin = keyframes`from { transform: rotate(0deg) } to { transform: rotate(360deg) }`;

export const ModalOverlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 1300;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  animation: ${fadeIn} 0.2s ease;
`;

export const ModalBox = styled.div`
  background: #ffffff;
  border-radius: 16px;
  width: 100%;
  max-width: 460px;
  box-shadow:
    0 24px 64px rgba(41, 52, 97, 0.16),
    0 4px 16px rgba(0, 0, 0, 0.08),
    0 0 0 1px rgba(226, 232, 240, 0.8);
  overflow: hidden;
  animation: ${slideUp} 0.28s cubic-bezier(0.34, 1.3, 0.64, 1);
`;

export const ModalHeader = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 22px 24px 18px;
  background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
  border-bottom: 1px solid #e2e8f0;
`;

export const ModalTitleGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 14px;
`;

export const ModalTitle = styled.h2`
  font-size: 16px;
  font-family: ${theme.fonts.primaryFontSemiBold};
  color: #293461;
  margin: 0 0 2px;
  letter-spacing: -0.2px;
`;

export const ModalSub = styled.p`
  font-size: 12px;
  color: #949ab0;
  margin: 0;
  font-weight: 400;
`;

export const ModalBody = styled.div`
  padding: 22px 24px;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const FieldLabel = styled.label`
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.6px;
  color: #949ab0;
  display: flex;
  align-items: center;
  gap: 3px;
`;

export const CurrencyHint = styled.p`
  font-size: 11.5px;
  color: #949ab0;
  margin: 0;
  font-weight: 500;
`;

export const ModalFooter = styled.div`
  padding: 16px 24px;
  border-top: 1px solid #e2e8f0;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  background: #f8f9fa;
`;

export const SaveBtn = styled.button`
  padding: 10px 22px;
  background: #00838c;
  color: #ffffff;
  border: none;
  border-radius: 9px;
  font-size: 13.5px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 150px;
  justify-content: center;
  &:active:not(:disabled) {
    transform: translateY(0);
  }
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    transform: none;
  }
`;

const SpinnerWrap = styled.span`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const Spinner = styled.span`
  width: 14px;
  height: 14px;
  border: 2px solid rgba(255, 255, 255, 0.35);
  border-top-color: #ffffff;
  border-radius: 50%;
  animation: ${spin} 0.7s linear infinite;
  display: inline-block;
`;

export const AgentLink = styled.button`
  background: none;
  border: none;
  color: #00838c;
  cursor: pointer;
  font-size: 12px;
  font-weight: 600;
  padding: 0;
  transition: all 0.2s ease;
  text-align: left;
  &:hover {
    text-decoration: underline;
  }
`;

const StickyHeader = styled.div`
  position: sticky;
  top: 74px;
  z-index: 100;
  background: white;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
`;
